import { render, staticRenderFns } from "./Game5.vue?vue&type=template&id=3fdf84b7&scoped=true&"
import script from "./Game5.vue?vue&type=script&lang=js&"
export * from "./Game5.vue?vue&type=script&lang=js&"
import style0 from "./Game5.vue?vue&type=style&index=0&id=3fdf84b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf84b7",
  null
  
)

export default component.exports